<template>
  <div>
    <nav
      class="navbar navbar-transparent navbar-color-on-scroll fixed-top navbar-expand-lg p-0"
      color-on-scroll="100"
      id="sectionsNav"
    >
      <div class="container">
        <div class="navbar-translate">
          <div
            class="d-flex flex-column justify-content-center align-items-center py-2"
          >
            <img
              src="../../public/assets/images/gtl-logo.png"
              class="img-fluid"
              style="width:70px"
              alt
            />
            <!-- <div class="text-orange text-center">
              <b>Impact Portal</b>
            </div> -->
          </div>
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="sr-only">Toggle navigation</span>
            <span class="navbar-toggler-icon"></span>
            <span class="navbar-toggler-icon"></span>
            <span class="navbar-toggler-icon"></span>
          </button>
        </div>
        <div class="collapse navbar-collapse">
          <ul class="navbar-nav ml-auto">
            <li class="nav-item">
              <router-link class="nav-link" to="/">Home</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/ecosystem"
                >Ecosystem</router-link
              >
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/young-africa-works"
                >Young Africa Works</router-link
              >
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/mlab">Mlab</router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div class="container-fluid app-container p-0 m-0">
      <slot />
    </div>

    <footer class="d-flex justify-content-between align-items-center">
      <div
        class="container d-flex justify-content-between align-items-center px-md-0"
      >
        <h5>&#169; Impact Portal 2021</h5>
        <div class="icons">
          <a href="https://twitter.com/ghanatechlab" target="_blank">
            <img src="../../public/assets/images/twitter.svg" alt />
          </a>
          <a href="https://instagram.com/ghanatechlab_gtl" target="_blank">
            <img src="../../public/assets/images/insta.svg" alt />
          </a>
          <a href="https://facebook.com/ghanatechlab" target="_blank">
            <img
              class="fbook"
              src="../../public/assets/images/facebook.svg"
              alt
            />
          </a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
footer {
  width: 100%;
  background: black;
  color: white;
  height: 10vh;
}

footer > div {
  width: 100%;
}

footer > div h5 {
  font-size: 1em;
}

.icons > img {
  margin-left: 1rem;
}

.app-container {
  min-height: 100vh;
}
</style>
